import { Toaster } from 'sonner';

import { type IAuthenticatedUser } from '../interfaces/auth.interface';

/** Mount once at the root of an app so alerts raised through useAlertStore have somewhere to appear. */
export function AlertComponent({
	theme,
}: {
	theme?: IAuthenticatedUser['preferredTheme'];
}) {
	return (
		<Toaster
			visibleToasts={4}
			duration={7000}
			closeButton
			position="bottom-left"
			theme={theme || 'light'}
			toastOptions={{ className: '!rounded-2xl !shadow-lg !border-slate-300' }}
		/>
	);
}
